module.exports = __webpack_public_path__ + "static/media/vendorInvoice.e4a49263.svg";